/**
 * @fileoverview Prompt template for multi-reference-image-creator-fal-v2.
 *
 * This agent doesn't use a text prompt template - it generates images directly
 * from the imagePrompt input and reference images. This file exists for
 * consistency with the agent-per-folder pattern.
 */

export const prompt = '';
